import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useCheckoutState } from '../../../utils/checkoutState';
import { getAssetUrl } from '../../../utils/config';
import Price from '../../atoms/Price';
import { showDefaultError } from '../Notifications';
import './style.scss';

type PriceSummaryProps = {
  total: number;
  shipping: number;
  subtotal: number;
  giftCard?: number;
  className?: string;
};

const PriceSummary = (props: PriceSummaryProps) => {
  const { total, shipping, subtotal, giftCard } = props;
  const { removeVoucher, checkoutState, removeGiftCard } = useCheckoutState();
  const { vouchers = [], payment } = checkoutState.orderState;

  const onRemoveGiftCard = async () => {
    try {
      const { giftCards = [] } = payment || { giftCards: [] };
      if (giftCards[0].recurringPaymentOptionId) {
        await removeGiftCard({ id: giftCards[0]?.recurringPaymentOptionId });
      }
    } catch (e) {
      showDefaultError();
    }
  };

  const onRemoveVoucher = async (id: string) => {
    try {
      await removeVoucher({ id });
    } catch (e) {
      showDefaultError();
    }
  };

  return (
    <div className={classNames('price-summary', props.className)}>
      <dl className="price-summary__section">
        <dt>
          <FormattedMessage id="basket.subtotal" />
        </dt>
        <dd>
          <Price price={subtotal} />
        </dd>
      </dl>
      <dl className="price-summary__section">
        <dt>
          <FormattedMessage id="basket.shipping" />
        </dt>
        <dd>{shipping === 0 ? <FormattedMessage id="generic.free" /> : <Price price={shipping} />}</dd>
      </dl>
      {vouchers.map(voucher => (
        <dl className="price-summary__section" key={voucher.id}>
          <dt>{voucher.name}</dt>
          <dd>
            <div className="price-summary--removable">
              <Price price={voucher.discount * -1} />
              <img src={getAssetUrl('common/remove.svg')} onClick={() => onRemoveVoucher(voucher.id)} />
            </div>
          </dd>
        </dl>
      ))}

      {!!giftCard && (
        <dl className="price-summary__section">
          <dt>
            <FormattedMessage id="basket.giftCard" />
          </dt>
          <dd>
            <div className="price-summary--removable">
              <Price price={giftCard * -1} />
              <img src={getAssetUrl('common/remove.svg')} onClick={onRemoveGiftCard} />
            </div>
          </dd>
        </dl>
      )}
      <dl className="price-summary__section price-summary__section--total">
        <dt>
          <FormattedMessage id="basket.total" />
        </dt>
        <dd>
          <Price price={total} isLarge />
          <div className="price-summary--includingTax">
            <FormattedMessage id="basket.includingTax" />
          </div>
        </dd>
      </dl>
    </div>
  );
};

export default PriceSummary;
